import { httpClient } from './httpClient';

const base = '/api/matriculas';

export const listarMatriculas = (params = {}) => {
  const entries = Object.entries(params).filter(([, v]) => v !== null && v !== undefined && v !== '' && v !== 'all');
  const qs = new URLSearchParams(entries.map(([k, v]) => [k, String(v)])).toString();
  return httpClient.get(`${base}${qs ? `?${qs}` : ''}`);
};
export const listarMatriculasPendientes = async () => {
  const porPagina = 200;
  let pagina = 1;
  let data = [];
  let total = Infinity;

  while (data.length < total) {
    const response = await httpClient.get(`${base}?estado_pago=pendiente,parcial&porPagina=${porPagina}&pagina=${pagina}`);
    const rows = Array.isArray(response?.data) ? response.data : [];
    if (rows.length === 0) break;
    data = data.concat(rows);
    total = Number(response?.total) || data.length;
    pagina += 1;
  }

  return { data, total: data.length };
};
export const buscarMatriculas = async (params = {}) => {
  const entries = Object.entries(params).filter(([, value]) => value !== undefined && value !== null && `${value}`.trim() !== "");
  const query = new URLSearchParams(entries.map(([key, value]) => [key, String(value)]));
  const qs = query.toString();
  const response = await httpClient.get(`${base}${qs ? `?${qs}` : ""}`);
  return Array.isArray(response) ? response : (Array.isArray(response?.data) ? response.data : []);
};
export const obtenerMatricula = (id) => httpClient.get(`${base}/${id}`);
export const obtenerFichaMatricula = (id) => httpClient.get(`${base}/${id}/ficha`);
export const crearMatricula = (payload) => httpClient.post(base, payload);
export const actualizarMatricula = (id, payload) => httpClient.put(`${base}/${id}`, payload);
export const eliminarMatricula = (id) => httpClient.del(`${base}/${id}`);
export const transferirMatricula = (id, payload) => httpClient.post(`${base}/${id}/transferir`, payload);

const matriculasService = {
  listar: listarMatriculas,
  buscar: buscarMatriculas,
  obtener: obtenerMatricula,
  crear: crearMatricula,
  actualizar: actualizarMatricula,
  eliminar: eliminarMatricula,
};

export default matriculasService;
